let Menu = {
	//  !  防止模块重名
	namespaced:true,
	state: {
		// isCollapse: false,
	},
	mutations: {
		// 点击按钮，mutation处理，在返回给页面，做出相应操作
		// toggleMenu(state) { // 5、改
		// 	state.isCollapse = !state.isCollapse
		// },
	},
	// 计算属性
	getters: {
		// iconName: (state) => {
		// 	// 一、根据现有的布尔值推导出是否显示相应的图标
		// 	return state.isCollapse ? 'el-icon-s-unfold' : 'el-icon-s-fold'
		// }
	}
}

export default Menu;
